export const TICKER_CONSTANTS = {
  FORM: {
    ALIASES_MIN_HEIGHT: "3rem",
    ALIASES_MAX_LENGTH: 500,
    ALIAS_MAX_LENGTH: 50,
    ALIAS_PATTERN: /^[a-zA-Z0-9\s\-_.]+$/,
  },
  TABLE: {
    PAGE_SIZE: 40,
  },
} as const;
